const TASK_ID_CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
const TASK_ID_LENGTH = 20;

/**
 * Generate a unique 20-character random ID for tasks
 */
export function generateTaskId(): string {
  const array = new Uint8Array(TASK_ID_LENGTH);
  crypto.getRandomValues(array);
  let id = '';
  for (let i = 0; i < TASK_ID_LENGTH; i++) {
    id += TASK_ID_CHARS[array[i] % TASK_ID_CHARS.length];
  }
  return id;
}
